const maxSlidesPerView = document.querySelectorAll(".pp-videos-slider .swiper-slide").length
const homepageVideosSwiper = new Swiper(".pp-videos-slider", {
  slidesPerView: 1.8,
  spaceBetween: 16,
  breakpoints: {
    575: {
      slidesPerView: 2.5 < maxSlidesPerView ? 2.5 : maxSlidesPerView,
    },
    768: {
      slidesPerView: 3 < maxSlidesPerView ? 3 : maxSlidesPerView,
    },
    915: {
      slidesPerView: 4 < maxSlidesPerView ? 4 : maxSlidesPerView,
    },
    1200: {
      slidesPerView: 5 < maxSlidesPerView ? 5 : maxSlidesPerView,
    },
  },
  // autoplay: {
  //   delay: 1,
  //   disableOnInteraction: true,
  // },
  // speed: 9500,
});

